export const BUTTON_TYPE = {
  primary: 'primary',
  secondary: 'secondary',
  text: 'text',
  textPrimary: 'textPrimary',
  textDanger: 'textDanger',
  link: 'link'
} as const

export const ICON_SIZE = '1.15em'
